import React, { useState, useMemo } from 'react'

import queryString from 'query-string'

import { withRouter } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'

import { setFlag, updateViolations } from '../../../redux/actions'
import { setAllChecked } from '../../../redux/actions/select'

import {
  Grid, Fab, Tooltip
} from '@material-ui/core'

import { Toast as NotificationToast } from './Toast'
import { Toast, getViolationIndex } from '../../../utils'

import { makeStyles, lighten, darken } from '@material-ui/core/styles'

import FlagIcon from '@material-ui/icons/Flag'
// import RemoveIcon from '@material-ui/icons/Remove'
import CloseIcon from '@material-ui/icons/Close'

const useStyles = makeStyles((theme) => ({
  flagContainer: {
    width: 'auto',
    height: 'auto',
    zIndex: 1
  },
  flagBtn: {
    backgroundColor: lighten('#3984f7', 0.40),
    color: '#fff',
    '&:hover': {
      backgroundColor: lighten('#3984f7', 0.30)
    }
  },
  flagLine: {
    position: 'absolute',
    zIndex: 1,
    // color: '#656565'
    color: darken('#fff', 0.05)
  },
  removeLine: {
    // color: '#AEAEAE',
    color: darken('#fff', 0.25),
    fontSize: '3em'
  },
  removeBtn: {
    backgroundColor: '#3984f7',
    color: '#fff',
    '&:hover': {
      backgroundColor: darken('#3984f7', 0.10)
    }
  }
}))

const Flagger = (props) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const Captures = useSelector(state => state.violations.violations.captures)
  const { PageCaptureLimit: PageLimit, Filter } = useSelector(state => state.selection)
  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageLimit])

  const handleFlagMod = (shouldFlag) => {
    switch (parsedProps.view) {
      case 'single':
      case 'list': {
        const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })

        const captureInfo = (() => {
          if (
            Boolean(Captures.length) && Boolean(parsedProps.view) && typeof captureIx === 'number' && typeof Captures[captureIx] === 'object' &&
            Boolean(Captures[captureIx].violationID)
          ) {
            return Captures[captureIx]
          }

          return {}
        })()

        if (captureInfo && Boolean(captureInfo.violationID)) {
          const violations = [{ violationID: captureInfo.violationID }]
          dispatch(setFlag(violations, shouldFlag, () => fireFlagSuccess(shouldFlag, violations), () => fireFlagFailure(shouldFlag)))
        }

        break
      }
      case 'grid': {
        if (Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length)) {
          const flagCaptures = parsedProps.captureTrgts.reduce((arr, captureNum) => {
            const captureIx = getViolationIndex({ captureNum, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })

            const captureInfo = (() => {
              if (typeof captureIx === 'number') { return Captures[captureIx] }
              return {}
            })()

            if (captureInfo && Boolean(captureInfo.violationID)) {
              const { violationID, isFlagged = false } = captureInfo

              if ((shouldFlag && !isFlagged) || (!shouldFlag && isFlagged)) {
                arr.push({ violationID })
              }
            }

            return arr
          }, [])

          if (flagCaptures.length) {
            dispatch(setAllChecked(false))
            dispatch(setFlag(flagCaptures, shouldFlag, () => fireFlagSuccess(shouldFlag, flagCaptures), () => fireFlagFailure(shouldFlag)))

            props.history.push({
              pathname: '/captures',
              search: `?view=grid&page=${parsedProps.page}&activeCaptures=[]`
            })
          } else {
            Toast.fire({
              icon: 'info',
              title: 'Please select one or more captures.'
            })
          }
        } else {
          Toast.fire({
            icon: 'info',
            title: 'Please select one or more captures.'
          })
        }
        break
      }
      default: break
    }
  }

  const fireFlagSuccess = (shouldFlag = false, captureTrgts = []) => {
    const flaggedOnly = (() => {
      if (
        (typeof Filter === 'object' && Array.isArray(Filter.statusesToAdd) && Boolean(Filter.statusesToAdd.length)) ||
        (typeof Filter === 'object' && Array.isArray(Filter.captureAreas) && Boolean(Filter.captureAreas.length))
      ) {
        const flagStatus = Boolean(Filter.statusesToAdd.length) && Boolean(Filter.statusesToAdd.find(
          (filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)
        ))

        const flagCapture = Boolean(Filter.captureAreas.length) && Boolean(Filter.captureAreas.find(
          (filterInfo) => typeof filterInfo === 'string' && (/Flagged/ig).test(filterInfo)
        ))

        return (flagStatus || flagCapture)
      }

      return false
    })()

    if (shouldFlag) {
      NotificationToast(false, 'Capture has been flagged!')
    } else {
      NotificationToast(false, 'Capture has been un-flagged!')
    }

    const newCaptures = (Captures || []).reduce((arr, captureInfo) => {
      if (captureInfo && Boolean(captureInfo.violationID)) {
        const isTarget = Boolean(captureTrgts.find((trgtInfo) => trgtInfo && Boolean(trgtInfo.violationID) && trgtInfo.violationID === captureInfo.violationID))

        if (isTarget) { captureInfo.isFlagged = shouldFlag }

        if ((flaggedOnly && captureInfo.isFlagged) || !flaggedOnly) {
          arr.push({ ...captureInfo })
        }
      }

      return arr
    }, [])

    dispatch(updateViolations(newCaptures))
  }

  const fireFlagFailure = (shouldFlag = false) => {
    if (shouldFlag) {
      NotificationToast(true, 'Failed to add flag!')
    } else {
      NotificationToast(true, 'Failed to un-flag!')
    }
  }

  const getFlagStatus = () => {
    if (parsedProps.view && Captures && Boolean(Captures.length)) {
      const { view } = parsedProps

      if ((view === 'single' || view === 'list') && typeof parsedProps.captureTrgts === 'number') {
        const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageLimit, page: parsedProps.page, currentView: parsedProps.view })

        const captureInfo = (() => {
          if (typeof captureIx === 'number') { return Captures[captureIx] }

          return null
        })()

        if (typeof captureInfo === 'object' && captureInfo.isFlagged) {
          return (
            <Tooltip title='Remove Flag' placement='left' arrow>
              <Fab
                variant='round'
                size='large'
                className={classes.removeBtn}
                onClick={() => handleFlagMod(false)}
              >
                <CloseIcon className={classes.removeLine} />
                <FlagIcon className={classes.flagLine} />
              </Fab>
            </Tooltip>
          )
        }
      } else if (
        view === 'grid' && Array.isArray(parsedProps.captureTrgts) && Boolean(parsedProps.captureTrgts.length)
      ) {
        const isAllFlagged = parsedProps.captureTrgts.reduce((bool, captureNum) => {
          if (typeof captureNum === 'number') {
            const captureIx = getViolationIndex({ captureNum, pageLimit: PageLimit, page: parsedProps.page, currentView: view })

            const captureInfo = (() => {
              if (typeof captureIx === 'number') { return Captures[captureIx] }
              return {}
            })()

            if (captureInfo && Boolean(captureInfo.violationID) && !captureInfo.isFlagged) { bool = false }
          }

          return bool
        }, true)

        if (isAllFlagged) {
          return (
            <Tooltip title='Remove Flag' placement='left' arrow>
              <Fab
                variant='round'
                className={classes.removeBtn}
                size='large'
                onClick={() => handleFlagMod(false)}
              >
                <CloseIcon className={classes.removeLine} />
                <FlagIcon className={classes.flagLine} />
              </Fab>
            </Tooltip>
          )
        }
      }
    }

    return (
      <Tooltip title='Flag Capture' placement='left' arrow>
        <Fab
          className={classes.flagBtn}
          size='large'
          variant='round'
          onClick={() => handleFlagMod(true)}
        >
          <FlagIcon />
        </Fab>
      </Tooltip>
    )
  }

  return (
    <>
      <Grid container direction='column' className={classes.flagContainer} spacing={2}>
        <Grid item>
          {getFlagStatus()}
        </Grid>

        {/* <Grid item>
          <Tooltip title='Remove Flag' placement='left' arrow>
            <Fab
              variant='round'
              size='large'
              onClick={() => handleFlagMod(false)}
            >
              <CloseIcon className={classes.removeLine} />
              <FlagIcon className={classes.flagLine} />
            </Fab>
          </Tooltip>
        </Grid> */}
      </Grid>
    </>
  )
}

export default withRouter(Flagger)
